const MIN_EAN_LENGTH = 8;
const MAX_EAN_LENGTH = 14;
const MAX_AVERAGE_INTERVAL_MS = 50;
const MAX_ENTER_DELAY_MS = 120;

export function isFastHidEan(
  value: string,
  keyTimes: number[],
  enterTime: number,
): boolean {
  const normalized = value.trim();
  if (!/^\d+$/.test(normalized)) return false;
  if (
    normalized.length < MIN_EAN_LENGTH ||
    normalized.length > MAX_EAN_LENGTH ||
    keyTimes.length !== normalized.length
  )
    return false;
  if (enterTime - keyTimes[keyTimes.length - 1] > MAX_ENTER_DELAY_MS)
    return false;
  if (keyTimes.length === 1) return true;
  return (
    (keyTimes[keyTimes.length - 1] - keyTimes[0]) / (keyTimes.length - 1) <=
    MAX_AVERAGE_INTERVAL_MS
  );
}
